import React, { useContext, useMemo } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { PacksDispatchContext, PacksContext } from '../ApiProvider';

import Button from 'CommonComponents/Button';
import TextFormField from 'CommonComponents/TextFormField';

const PackCategorySchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
});

export default function PackCategoryForm({ id, type }) {
    const apiCall = useContext(PacksDispatchContext);
    const { simplePackCategories, contractorPackCategories } = useContext(PacksContext);
    const isContractor = type === 'createContractorCategory';
    const categories = isContractor ? contractorPackCategories : simplePackCategories;

    const details = useMemo(() => {
        return id
            ? categories.find((c) => c.id == id) || { name: '', id: false, pack_contractor: isContractor ? 1 : 0 }
            : { name: '', id: false, pack_contractor: isContractor ? 1 : 0 };
    }, [categories, id, isContractor]);

    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: details.name || '',
            }}
            validationSchema={PackCategorySchema}
            onSubmit={(values) => {
                const data = {
                    ...details,
                    ...values,
                    pack_contractor: isContractor ? 1 : 0,
                };
                apiCall('packCategorySave', data);
            }}
        >
            {({ isSubmitting, handleSubmit }) => (
                <>
                    <TextFormField label={$t('Name')} type="text" required={true} name="name" />

                    <div className="modal__footer">
                        <Button variant="secondary" onClick={() => apiCall('form', false)} disabled={isSubmitting}>
                            {$t('Cancel')}
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                            {details.id ? $t('Update') : $t('Create')}
                        </Button>
                    </div>
                </>
            )}
        </Formik>
    );
}
